import { useEffect, useState } from 'react';
import { fetchAndActivate, getValue } from 'firebase/remote-config';
import { remoteConfig } from '../config/firebase';

/**
 * Returns a Firebase Remote Config string parameter, starting with its
 * configured default (or the provided fallback) and updating once the fetched
 * template activates. Fetch failures keep the default — callers always get a
 * usable value.
 */
export function useRemoteConfigString(key: string, fallback: string): string {
  const [configValue, setConfigValue] = useState<string>(() => {
    const defaultValue = getValue(remoteConfig, key).asString();
    return defaultValue || fallback;
  });

  useEffect(() => {
    let isMounted = true;
    fetchAndActivate(remoteConfig)
      .then(() => {
        if (!isMounted) return;
        const fetchedValue = getValue(remoteConfig, key).asString();
        if (fetchedValue) {
          setConfigValue(fetchedValue);
        }
      })
      .catch((error) => {
        console.error(`[RemoteConfig] Fetch failed for ${key}, keeping default:`, error);
      });
    return () => {
      isMounted = false;
    };
  }, [key]);

  return configValue;
}
